export default "/images/vendor/flag-icons/flags/1x1/pw.svg?a831460a026477de3470f457ca432bbd";